import { useCallback, useRef, useState } from 'react';

type props = {
    debounceDuration? : number
    callback : (searchText : string) => void
    placeholder? : string
}

export default function SearchBox( {debounceDuration = 1000, callback, placeholder} : props ){
    const [isEmpty, setIsEmpty] = useState(true)
    const inputRef = useRef<HTMLInputElement | null>(null)
    const timeoutIdRef = useRef<number>()
    const resetSearch = useCallback( () => {
        if(!isEmpty){
            setIsEmpty(true)
            inputRef.current!.value = ""
            callback("")
        }
    }, [callback, isEmpty])
    
    const handleChange = useCallback( (text : string) => {
        setIsEmpty(text === "")
        if(timeoutIdRef.current){
            clearTimeout(timeoutIdRef.current)
            timeoutIdRef.current = undefined
        }

        timeoutIdRef.current = setTimeout( () => callback(text), debounceDuration, text)
    }, [callback, debounceDuration])


    return (
        <div className="flex h-fit text-xs border bg-white rounded overflow-hidden">
            <input
                ref={inputRef}
                type="text" 
                placeholder={placeholder} 
                className="pl-2 w-80 h-8" 
                onChange={ e => handleChange(e.target.value)}
            />
            <label htmlFor="search" onClick={resetSearch} className={`fas ${isEmpty ? "fa-search" : "fa-close hover:bg-primary text-red-600 hover:text-white cursor-pointer"} flex justify-center items-center w-8 h-8 xl:font-bold`} />
        </div>
    )
}